export default __webpack_public_path__ + "static/media/category_7f741d10.83f7f70a.png";